import { API_ROUTES, request, requestWithPaginationHeader } from '../instance';
import { User, UserRolesEnum } from '@shared';

export type UserAPI = {
  partnerUUIDs: string[];
  roles: Array<UserRolesEnum>;
  verified?: boolean;
};

export enum Roles {
  Instructor = 'Instructor',
  Student = 'Student',
}

export type ManageUserAPI = {
  uuid: string;
  firstName: string;
  lastName: string;
  email: string;
  roles: Roles[];
};

export type PayloadManageUsers = {
  offset: number;
  limit: number;
};

export const getUserRoles = () => {
  return request<UserAPI>({
    url: `${API_ROUTES.user()}`,
    method: 'GET',
  });
};

export const getUsers = (partner: string, course: string, params: PayloadManageUsers) => {
  return requestWithPaginationHeader<ManageUserAPI[]>({
    url: `${API_ROUTES.users(partner, course, params)}`,
    method: 'GET',
  });
};

export const removeFromCourseUser = (partner: string, course: string, userId: string) =>
  request({
    url: `${API_ROUTES.userActions(partner, course, userId)}/removeFromCourse`,
    method: 'POST',
  });

export const undoFromCourseUser = (partner: string, course: string, userId: string) =>
  request({
    url: `${API_ROUTES.userActions(partner, course, userId)}/addToCourse`,
    method: 'POST',
  });

export const updateUserRoles = ({
  partner,
  course,
  userId,
  data,
}: {
  partner: string;
  course: string;
  userId: string;
  data: Roles[];
}) =>
  request({
    url: `${API_ROUTES.userActions(partner, course, userId)}/roles`,
    method: 'POST',
    data,
  });

export const findExistingUsers = (partner: string, course: string, data: User[]) =>
  request({
    url: `${API_ROUTES.addUsersToCourse(partner, course)}/find-existing`,
    method: 'POST',
    data,
  });

export const inviteUsers = (partner: string, course: string, data: User[]) =>
  request({
    url: `${API_ROUTES.addUsersToCourse(partner, course)}/invite`,
    method: 'POST',
    data,
  });
